export { default } from './AccordionDetails';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/AccordionDetails/index.js
// module id = 784
// module chunks = 121